module.exports = __webpack_public_path__ + "img/angular.84c42cef.png";